import * as React from 'react';
import * as styles from './PaymentAmount.css';
import { UIHeading2 } from '@cian/ui-kit';
import { formatMoney } from '../../../utils/string';

interface IProps {
  price: number;
  checkbox: React.ReactNode;
}

export const PaymentAmount = (props: IProps) => {
  const { price, checkbox } = props;

  return (
    <>
      <UIHeading2 data-testid="widget|text|productPrice">{formatMoney(price)}</UIHeading2>

      {checkbox && <div className={styles['checkbox_wrapper']}>{checkbox}</div>}
    </>
  );
};
